// @flow

import * as React from 'react';
import { Pressable, useWindowDimensions, View } from 'react-native';
import { FormattedMessage } from 'react-intl';
import { pageStyles } from '../defaultPageStyles';
import Text from '../../components/CustomText/CustomText';

type Props = {
    index: Number,
    item: Object,
    addedChannels: Array<Object>,
    setAddedChannels: () => void,
    setRemainingChannels: () => void,
}

export const setRowStyle = (hovered, item, index, width) => {
    const rowStyles = [pageStyles.horizontal_pad];

    // in mobile view make the rows higher
    if (width < 600) {
        rowStyles.push(pageStyles.large_rows);
    } else {
        rowStyles.push(pageStyles.small_rows);
    }

    // if the row is even add grey background to it
    if (index % 2 === 0) {
        rowStyles.push(pageStyles.grey_background);
    }

    // if the row is hovered change the color
    if (hovered) {
        rowStyles.push(pageStyles.hovered);
    }
    return rowStyles;
};

const RemainingChannelItem = (props: Props) => {
    const {
        index, item, addedChannels, setAddedChannels, setRemainingChannels,
    } = props;

    const { width } = useWindowDimensions();

    const [hovered, setHovered] = React.useState(false);

    const addChannel = React.useCallback(() => {
        if (addedChannels.includes(item)) {
            return;
        }
        setAddedChannels([...addedChannels, item]);
        setRemainingChannels((channels) => channels.filter((value) => value.uuid !== item.uuid));
    }, [addedChannels, item, setAddedChannels, setRemainingChannels]);

    return (
        <View
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={setRowStyle(hovered, item, index, width)}
        >
            <View
                style={pageStyles.channel_items_container}
            >
                <View style={
                    width > 600
                        ? [pageStyles.channel_items, pageStyles.channel_items_number_column]
                        : [pageStyles.channel_items, pageStyles.channel_items_number_column_phone]
                }
                />
                <Text style={
                    width > 600
                        ? [pageStyles.channel_items, pageStyles.channel_items_name_column]
                        : [pageStyles.channel_items, pageStyles.channel_items_name_column_phone]
                }
                >
                    {item.name}
                </Text>
                {width > 600 && (
                    <>
                        <Text
                            style={[pageStyles.channel_items, pageStyles.channel_items_third_column]}
                        >
                            {item.category.name}
                        </Text>
                        <Text
                            style={[pageStyles.channel_items, pageStyles.channel_items_fourth_column]}
                        >
                            {item.resolution.name}
                        </Text>
                    </>
                )}

                <View
                    style={width > 600
                        ? [pageStyles.channel_items, pageStyles.channel_items_action_button_column]
                        : [pageStyles.channel_items, pageStyles.channel_items_action_button_column_phone_all]}
                >
                    <Pressable
                        onPress={addChannel}
                        style={pageStyles.action_buttons}
                    >
                        <Text style={pageStyles.light_blue}>
                            <FormattedMessage
                                id="add-channel"
                                defaultMessage="Add Channel"
                            />
                        </Text>

                    </Pressable>
                </View>
            </View>
        </View>
    );
};

export default RemainingChannelItem;
